import React from 'react';
import ThemeConfig from './theme';
import { Toaster } from 'react-hot-toast';
import UserContextProvider from './store/context/userContext';
import LoginContextProvider from './store/context/loginContext';
import ProjectContextProvider from './store/context/projectContext';
import UserAuthentication from './components/UserAuthentication';
import ProjectSettingsTabContextProvider from './store/context/projectSettingsTabContext';
import OrganisationContextProvider from './store/context/organisationContext';
import SideNavContextProvider from './store/context/sideNavContext';
import UnitRateContextProvider from './store/context/userRateIdLevelsData';

function App() {
    return (
        <ThemeConfig>
            <Toaster />
            <LoginContextProvider>
                <UserContextProvider>
                    <ProjectContextProvider>
                        <OrganisationContextProvider>
                            <ProjectSettingsTabContextProvider>
                                <SideNavContextProvider>
                                    <UnitRateContextProvider>
                                        <UserAuthentication />
                                    </UnitRateContextProvider>
                                </SideNavContextProvider>
                            </ProjectSettingsTabContextProvider>
                        </OrganisationContextProvider>
                    </ProjectContextProvider>
                </UserContextProvider>
            </LoginContextProvider>
        </ThemeConfig>
    );
}
export default App;
